import { render, staticRenderFns } from "./right-bar.vue?vue&type=template&id=e8e53490&scoped=true&"
import script from "./right-bar.vue?vue&type=script&lang=ts&"
export * from "./right-bar.vue?vue&type=script&lang=ts&"
import style0 from "./right-bar.vue?vue&type=style&index=0&id=e8e53490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e53490",
  null
  
)

export default component.exports